import script from "./loaderGenerateTaskDetails.vue?vue&type=script&lang=ts&setup=true"
export * from "./loaderGenerateTaskDetails.vue?vue&type=script&lang=ts&setup=true"

import "./loaderGenerateTaskDetails.vue?vue&type=style&index=0&id=a462986a&lang=css"

const __exports__ = script;

export default __exports__